import { useArrayUnique } from '@vueuse/core';
import { hash } from 'ohash';
import type { RadioBlockOption } from 'theme/components/molecules/RadioBlock.vue';

type Address = {
  id: string;
  prefecture: string;
  city: string;
  town: string;
  jisx0402: string;
};

export const useDiagnosisPostalCodeQuestion = (
  postalCode: RefOrGetterFunction<Nullable<string>>
) => {
  const { result: postalCodeResult } = usePostalCodeResult(postalCode);
  const rawAddressChoises = computed<Address[]>(() => {
    const result = postalCodeResult.value ?? [];
    return result
      .map(({ prefecture, city, town, jisx0402 }) => ({
        prefecture,
        city,
        town,
        jisx0402,
      }))
      .map((address) => ({
        id: hash(address),
        ...address,
      }));
  });

  // prefecture, city, townしか住所データとして採用しないと、
  // それ以下の細かい情報がない分選択肢の重複が発生するので排除する。
  const dedupedAddressChoises = useArrayUnique(
    rawAddressChoises,
    (a, b) => a.id === b.id
  );

  const addressOptions = computed<
    RadioBlockOption<Nullable<Address>, Address>[]
  >(() => {
    return dedupedAddressChoises.value.map((address) => ({
      value: address,
      content: address,
    }));
  });

  return {
    addressOptions,
  };
};
